export const EquipementData = [
  {
    id: 1,
    image: require("../assets/images/about-gehl.webp"),
    title: "Mini Chargeuse",
    products: [
      {
        id: 1,
        name: "R134",
        description1:
          "La chargeuse compacte R134 est une option très intéressante qui mêle un style compact avec une capacité de levage légèrement supérieure à celles de nos plus petites chargeuses. Elle est facilement transportable et très maniable.",
        description2:
          "Les nouvelles commandes intuitives du modèle soulagent la fatigue de l'opérateur après une longue journée à l'oeuvre. Des options comme le siège à suspension pneumatique et autres améliorations sont possibles pour encore plus de confort si vos journées de travail sont longues aux commandes de votre nouveau R134",

        image: require("../assets/images/machines/r134.webp"),
        images: [
          {
            image: require("../assets/images/machines/r134.webp"),
          },
          {
            image: require("../assets/images/machines/r134-2.webp"),
          },
          {
            image: require("../assets/images/machines/r134-4.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/kIt7n2psrMI", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Capacité nominale: ", value: "612 kg" },
          { key: "Hauteur de levage: ", value: "3584 mm" },
          { key: "Déport à hauteur totale et déversé: ", value: "528 mm" },
          { key: "Longueur hors-tout avec godet: ", value: "2952  mm" },
        ],
        brochure: require("../assets/brochure/R134.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Capacités",
            features: [
              { key: "Capacité nominale", value: "612 kg" }
            ],
          },
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Hauteur de travail - levé complètement",
                value: "3584 mm",
              },
              {
                key: "Hauteur à l’axe d’articulation – Entièrement levé",
                value: "2794 mm",
              },
              { key: "Hauteur hors tout en haut du ROPS", value: "1826 mm" },
              { key: "Angle de déversement à hauteur maximale", value: "42°" },
              { key: "Hauteur de déversement", value: " 2197 mm" },
              { key: "Longueur hors-tout avec godet", value: "2952 mm" },
              { key: "Déport à hauteur totale et déversé", value: "528 mm" },
              { key: "Cavage au sol", value: "29°" },
              { key: "Largeur du godet", value: "1524 mm" },
              { key: "Empattement", value: "932 mm" },
              { key: "Rayon de braquage - Avant avec godet", value: "1758 mm" },
              { key: "Rayon de braquage avant, sans godet", value: "1102 mm" },
              { key: "Rayon de braquage arrière", value: "1484 mm" },
            ],
          },
          {
            id: 3,
            type: "Performances",
            features: [
              { key: "Vitesse de déplacement (à vide)", value: "8.7 km/h" },
            ],
          },
          {
            id: 4,
            type: "Roues",
            features: [{ key: "Pneus standards", value: "10.00x16.5 HD" }],
          },
          {
            id: 5,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Yanmar" },
              { key: "Modèle du moteur", value: "4TNV88" },
              { key: "Norme moteur", value: "Stage 3A" },
              { key: "Puissance brute (kW)", value: "36.40 kW" },
              {
                key: "Couple max. / Régime moteur",
                value: "142 Nm",
              },
              { key: "Batterie", value: "12 V" },
              { key: "Démarreur (kW)", value: "12 V" },
            ],
          },
          {
            id: 7,
            type: "Capacités des réservoirs",
            features: [
              {
                key: "Réservoir à carburant",
                value: "47 l",
              }
            ],
          },
        ],
      },
      {
        id: 2,
        name: "R190",
        description1:
          "Avec pas moins de 862 kg de capacité nominale, mieux vaut ne pas sous-estimer cette machine. Équipée d'un contrepoids en option, elle est capable de soulever plus d'une tonne. Pensez à étudier vos options de transport de vos machines. Une version plus compacte peut peut-être mieux vous convenir.",
        description2:
          "Consultez nous pour tester la machine et trouver celle qui répond le mieux à vos besoins. Dans les exploitations agricoles et les chantiers de construction, les applications changent souvent. Cette machine pourrait bien devenir votre nouveau couteau suisse.",

        image: require("../assets/images/machines/r190.webp"),
        images: [
          {
            image: require("../assets/images/machines/r190.webp"),
          },
          {
            image: require("../assets/images/machines/r190-2.webp"),
          },
          {
            image: require("../assets/images/machines/r190-3.webp"),
          },
          {
            image: require("../assets/images/machines/r190-4.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/uLau2xnudt8", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Capacité nominale: ", value: "862 kg" },
          { key: "Hauteur de levage: ", value: "4013 mm" },
          { key: "Déport à hauteur totale et déversé: ", value: "572 mm" },
          { key: "Longueur hors-tout avec godet: ", value: "3226 mm" },
        ],
        brochure: require("../assets/brochure/R190.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Capacités",
            features: [
              { key: "Capacité nominale", value: "862 kg" },
              {
                key: "Capacité nominale avec contrepoids optionnel",
                value: "957 kg",
              },
              { key: "Poids à vide", value: "3121 kg" },
            ],
          },
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Hauteur de travail - levé complètement",
                value: "4013 mm",
              },
              {
                key: "Hauteur à l’axe d’articulation – Entièrement levé",
                value: "3061 mm",
              },
              { key: "Hauteur hors tout en haut du ROPS", value: "2032 mm" },
              { key: "Angle de déversement à hauteur maximale", value: "42°" },
              { key: "Hauteur de déversement", value: " 2311 mm" },
              { key: "Longueur hors-tout avec godet", value: "3226 mm" },
              { key: "Déport à hauteur totale et déversé", value: "572 mm" },
              { key: "Cavage au sol", value: "26" },
              { key: "Hauteur entre le siège et le sol", value: "991 mm" },
              { key: "Empattement", value: "1067 mm" },
              { key: "Largeur hors tout sans godet", value: "1631 mm" },
              { key: "Largeur du godet", value: "1676 mm" },
              { key: "Garde au sol", value: "165 mm" },
              { key: "Longueur hors-tout sans godet", value: "2388 mm" },
              { key: "Rayon de braquage - Avant avec godet", value: "2007 mm" },
              { key: "Rayon de braquage avant, sans godet", value: "1130 mm" },
              { key: "Rayon de braquage arrière", value: "1486 mm" },
            ],
          },
          {
            id: 3,
            type: "Performances",
            features: [
              {
                key: "Vitesse de déplacement maximale avec option deux vitesses",
                value: "20.10 km/h",
              },
              { key: "Vitesse de déplacement (à vide)", value: "12.10 km/h" },
            ],
          },
          {
            id: 4,
            type: "Roues",
            features: [{ key: "Pneus standards", value: "10.00x16.5 HD" }],
          },
          {
            id: 5,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Yanmar" },
              { key: "Modèle du moteur", value: "4TNV98C-NMSLV Stage V" },
              { key: "Norme moteur", value: "Stage V" },
              { key: "Puissance brute (kW)", value: "51.70 kW" },
              { key: "Puissance nette (kW)", value: "51 kW" },
              {
                key: "Couple max. / Régime moteur",
                value: "241 Nm / 1625 tr/min",
              },
              { key: "Batterie", value: "12 V" },
              { key: "Démarreur (kW)", value: "3 kW" },
            ],
          },
          {
            id: 6,
            type: "Hydraulique",
            features: [
              {
                key: "Flux standard - Système hydraulique auxiliaire",
                value: "70 l/min",
              },
              {
                key: "Système hydraulique auxiliaire haut débit – Option",
                value: "119 l/min",
              },
            ],
          },
          {
            id: 7,
            type: "Capacités des réservoirs",
            features: [
              {
                key: "Réservoir à carburant",
                value: "62.50 l",
              },
              {
                key: "Capacité du réservoir hydraulique",
                value: "30.30 l",
              },
              {
                key: "Cylindrée",
                value: "3.30 l",
              },
            ],
          },
          {
            id: 8,
            type: "Bruit et vibration",
            features: [
              { key: "Bruit à l’environnement (LwA)", value: "101 dB" },
              {
                key: "Vibrations au corps entier (ISO 2631-1)",
                value: "0.96 m/s²",
              },
              {
                key: "Vibration sur l’ensemble mains/bras",
                value: "< 1.50 m/s²",
              },
            ],
          },
        ],
      },
      {
        id: 3,
        name: "R260",
        description1:
          "Le modèle R260 est le plus grand de la gamme GEHL de chargeuses compactes à levage radial. 1179 kg de capacité nominale : difficile de trouver une application qui résisterait à cette machine.",
        description2:
          "Les options de commandes variées permettent de sélectionner la configuration la plus confortable, pour une productivité encore meilleure tout au long de la journée.",

        image: require("../assets/images/machines/r260.webp"),
        images: [
          {
            image: require("../assets/images/machines/r260.webp"),
          },
          {
            image: require("../assets/images/machines/r260-2.webp"),
          },
          {
            image: require("../assets/images/machines/r260-3.webp"),
          },
          {
            image: require("../assets/images/machines/r260-4.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/yY9qhnnhEGE", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Capacité nominale: ", value: "1179 kg" },
          { key: "Hauteur de levage: ", value: "4089 mm" },
          { key: "Déport à hauteur totale et déversé: ", value: "686 mm" },
          { key: "Longueur hors-tout avec godet: ", value: "3632 mm" },
        ],
        brochure: require("../assets/brochure/R260.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Capacités",
            features: [
              { key: "Capacité nominale", value: "1179 kg" },
              {
                key: "Capacité nominale avec contrepoids optionnel",
                value: "1261 kg",
              },
              { key: "Poids à vide", value: "3719 kg" },
            ],
          },
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Hauteur de travail - levé complètement",
                value: "4089 mm",
              },
              {
                key: "Hauteur à l’axe d’articulation – Entièrement levé",
                value: "3124 mm",
              },
              { key: "Hauteur hors tout en haut du ROPS", value: "2057 mm" },
              { key: "Angle de déversement à hauteur maximale", value: "40°" },
              { key: "Hauteur de déversement", value: " 2388 mm" },
              { key: "Longueur hors-tout avec godet", value: "3632 mm" },
              { key: "Déport à hauteur totale et déversé", value: "686 mm" },
              { key: "Cavage au sol", value: "28°" },
              { key: "Hauteur entre le siège et le sol", value: "1016 mm" },
              { key: "Empattement", value: "1257 mm" },
              { key: "Largeur hors tout sans godet", value: "1712 mm" },
              { key: "Largeur du godet", value: "1778 mm" },
              { key: "Garde au sol", value: "203 mm" },
              { key: "Longueur hors-tout sans godet", value: "2832 mm" },
              { key: "Rayon de braquage - Avant avec godet", value: "2286 mm" },
              { key: "Rayon de braquage avant, sans godet", value: "1422 mm" },
              { key: "Rayon de braquage arrière", value: "1626 mm" },
            ],
          },
          {
            id: 3,
            type: "Performances",
            features: [
              {
                key: "Vitesse de déplacement maximale avec option deux vitesses",
                value: "19.20 km/h",
              },
              { key: "Vitesse de déplacement (à vide)", value: "12.90 km/h" },
            ],
          },
          {
            id: 4,
            type: "Roues",
            features: [{ key: "Pneus standards", value: "12.00x16.5 HD" }],
          },
          {
            id: 5,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Yanmar" },
              { key: "Modèle du moteur", value: "4TNV98CT-NMSLV Stage V" },
              { key: "Norme moteur", value: "Stage V" },
              { key: "Puissance brute (kW)", value: "53.70 kW" },
              { key: "Puissance nette (kW)", value: "52.70 kW" },
              {
                key: "Couple max. / Régime moteur",
                value: "294 Nm / 2500 tr/min",
              },
              { key: "Batterie", value: "12 V" },
              { key: "Démarreur (kW)", value: "3 kW" },
            ],
          },
          {
            id: 6,
            type: "Hydraulique",
            features: [
              {
                key: "Flux standard - Système hydraulique auxiliaire",
                value: "90 l/min",
              },
              {
                key: "Système hydraulique auxiliaire haut débit – Option",
                value: "132.50 l/min",
              },
            ],
          },
          {
            id: 7,
            type: "Capacités des réservoirs",
            features: [
              {
                key: "Réservoir à carburant",
                value: "81.40 l",
              },
              {
                key: "Capacité du réservoir hydraulique",
                value: "30.30 l",
              },
              {
                key: "Cylindrée",
                value: "3.30 l",
              },
            ],
          },
          {
            id: 8,
            type: "Bruit et vibration",
            features: [
              { key: "Bruit à l’environnement (LwA)", value: "101 dB" },
              {
                key: "Vibrations au corps entier (ISO 2631-1)",
                value: "0.96 m/s²",
              },
              {
                key: "Vibration sur l’ensemble mains/bras",
                value: "< 1.50 m/s²",
              },
            ],
          },
        ],
      },
      {
        id: 4,
        name: "Autre Mini Chargeuse",
        description1:
          "Avec deux options de levage, Gehl vous offre la flexibilité à vos besoins. Les machines à levage radial sont mieux adapté lorsque la majorité du travail effectué est en dessous du niveau des yeux. Ascenseur vertical les machines sont idéales pour le levage et le déversement à des hauteurs plus élevées.",
        description2:
          " Les chargeuses compactes à levage radial Gehl offrent d'excellentes portée vers l'avant au milieu de la trajectoire de l'ascenseur. Ce qui offre d'excellentes performances pour le chargement camions à plateau, remblayage ou déversement sur un mur",

        image: require("../assets/images/machines/autre-mini.webp"),
        images: [
          {
            image: require("../assets/images/machines/v330.webp"),
          },
          {
            image: require("../assets/images/machines/r220.webp"),
          },
          {
            image: require("../assets/images/machines/V270.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/VKaueTF4AVM", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "R135", value: "" },
          { key: "V270 GEN:2", value: "" },
          { key: "V330 GEN:2", value: "" },
          { key: "V420", value: "" },
        ],
        brochure: require("../assets/brochure/full_product.pdf"),
        technicalFeatures: [
        ],
      },
    ],
  },
  {
    id: 2,
    image: require("../assets/images/machines/glb-x-920-background.webp"),
    title: "Tractopelle",
    products: [
      {
        id: 1,
        name: "GBL-X-920",
        description1:
          "Les chargeuses-pelleteuses GBL sont des tractopelles à la pointe de l’innovation et de la technologie. Equipées d’un large godet situé à l’avant et d’une pelle à l’arrière, elles vous aident à effectuer vos différentes opérations de construction : excavation du terrain, chargement, transport, déplacement des matériaux.. Grâce à leurs 4 roues motrices et une maniabilité tout-terrain sans faille, les chargeuses GBL peuvent opérer sur tous types de sols, y compris les sols boueux, accidentés et irréguliers. Ces caractéristiques inédites sur le marché de la manutention offrent une performance améliorée en excavation et nivellement.",
        description2:
          "Les chargeuses-pelleteuses GEHL sont d'une grande polyvalence. Il vous suffit de changer d’accessoires pour obtenir une solution répondant à chacune de vos problématiques : pinces pour soulever et transporter du bois ou des tubes,  godets  standards pour charger le vrac (graviers, sable, terre, céréale, compléments minéraux, fumier), godet grappins pour l’alimentation et l’ensilage, fourches à palettes, accessoires spécifiques pour tondre, forer, creuser, ratisser, excaver au-dessous du niveau de la plateforme de travail...",

        image: require("../assets/images/machines/glb-x-920-2.webp"),
        images: [
          {
            image: require("../assets/images/machines/glb-x-920-2.webp"),
          },
          {
            image: require("../assets/images/machines/glb-x-920-bg1.webp"),
          },
          {
            image: require("../assets/images/machines/glb-x-920-bg-2.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/ZxvkhO8XUIk", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Puissance nominale: ", value: "68kW | 92 ch | Perkins" },
          { key: "Poids opérationnel standard: ", value: "7590 kg" },
          { key: "Poids en ordre de marche 4WD: ", value: "7690 kg" },
        ],
        brochure: require("../assets/brochure/glb-x-920.pdf"),
        technicalFeatures: [
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Poids à vide ",
                value: "7620 Kg",
              },
              {
                key: "Poids à vide avec 4 roues motrices",
                value: "7620 Kg",
              },
              {
                key: "Poids à vide avec 4 roues motrices 7 en 1",
                value: "7908 Kg",
              },
              { key: "Empattement", value: "280 mm" },
              { key: "Longueur totale", value: "7330 mm" },
              { key: "Largeur totale", value: "2330 mm" },
              { key: "Hauteur totale", value: " 2830 mm" },
              { key: "Hauteur cabine", value: "3790 mm" },
              { key: "Hauteur totale", value: "591 mm" },
              { key: "Rayon de braquage extérieur sur pneus (non freiné / freiné)", value: "4200 mm / 3850 mm" },
              { key: "Rayon de braquage extérieur sur godet (non freiné / freiné)", value: "5700 mm / 5550 mm" },
              { key: "Pneus standards avant/arrière", value: "12,5x18-12PR / 16,9x28-12PR" },
            ],
          },
          {
            id: 3,
            type: "Performances",
            features: [
              { key: "Vitesse de déplacement avant 1ère / 2ème", value: "5,40 km/h / 8,60 km/h" },
              { key: "Vitesse de déplacement vers l'avant 3e / 4e", value: "19,90 km/h / 40 km/h" },

            ],
          },
          {
            id: 4,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Perkins" },
              { key: "Modèle du moteur", value: "1104C 44T Turbo Charged Water" },
              { key: "Max. capacité", value: "4,40 l" },
              { key: "Puissance brute (kW) / Puissance brute", value: "92Hp @ 2200 rpm" },
              {
                key: "Couple max. / Régime moteur",
                value: "395 Nm",
              }
            ],
          },
          {
            id: 5,
            type: "Transmission",
            features: [
              { key: "Type de transmission", value: "Carraro" },
              { key: "Nombre de vitesses (avant / arrière)", value: "4 / 4" },
            ],
          },
        ],
      },
    ],
  },
  {
    id: 3,
    image: require("../assets/images/machines/telescopic.webp"),
    title: "Chariot Télescopique",
    products: [
      {
        id: 1,
        name: "Tx-4017",
        description1:
          "Le chariot télescopique TX-4017 est conçu notamment pour les chantiers de grandes hauteurs. Il est capable de lever jusqu'à 17 m. de hauteur des charges jusqu'à 4 t. Adapté à des terrains difficiles, il possède une haute garde au sol et un rayon de braquage court qui le rendent aisément manoeuvrable.",
        description2:
          "Son excellente stabilité latérale et frontale en font un allié fiable sur vos chantiers.Robuste et conçu pour durer, ce chariot est équipé d'une porte basse tôlée et de composants de qualité qui vous assureront une grande longévité. Pour favoriser sa transportabilité, de nombreux points d'élingage ont été prévus. Multitâche, il s'adapte à vos besoins en changeant l'accessoire en tête de flèche.",

        image: require("../assets/images/machines/tx4017.webp"),
        images: [
          {
            image: require("../assets/images/machines/tx4017.webp"),
          },
          {
            image: require("../assets/images/machines/tx4017-2.webp"),
          },
          {
            image: require("../assets/images/machines/tx4017-3.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/1Z3n9OfqqzA", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Hauteur de levage: ", value: "16.55 m" },
          { key: "Capacité maximale: ", value: "4000 kg" },
          { key: "Dépot max: ", value: "13.08 m" },
          { key: "Moteur: ", value: "Perkins" },
        ],
        brochure: require("../assets/brochure/TX4017.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Capacités",
            features: [
              { key: "Max. Capacité", value: "4000 kg" },
              {
                key: "Max. Hauteur de levage",
                value: "17.40 m",
              },
              { key: "Longueur du bras", value: "13.48 m" },
            ]
          },
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Longueur hors tout au chariot",
                value: "6.20 m",
              },
              {
                key: "Largeur totale",
                value: "2.38 m",
              },
              {
                key: "Hauteur totale",
                value: "2.59 m",
              },
              { key: "Empattement", value: "2.90 m" },
              { key: "Garde au sol", value: "0.38 m" },
              { key: "Largeur hors tout de la cabine", value: " 0.85 m" },
              { key: "Rayon de braquage extérieur", value: "4.05 m" },
              { key: "Poids à vide (avec fourches)", value: "11275 kg" },
              { key: "Tailles des fourches", value: "1200 mm x 125 mm / 50 mm" }
            ],
          },
          {
            id: 3,
            type: "Performances",
            features: [
              { key: "Levage", value: "13.60 s" },
              { key: "Abaissement", value: "9.40 s" },
              { key: "Extension", value: "25 s" },
              { key: "Rétraction", value: "14.10 s" },
              { key: "Cavage", value: "4.10 s" },
              { key: "Déversement", value: "3.20 s" },

            ],
          },
          {
            id: 4,
            type: "Transmission",
            features: [
              { key: "Type de transmission", value: "Torque converter with Manual Gearbox" },
              { key: "Nombre de vitesses (avant / arrière)", value: "4 / 4" },
              { key: "Vitesse max. de déplacement", value: "28 Km/h" },
              { key: "Frein de parking", value: "Manuel" },
            ],
          },
          {
            id: 5,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Perkins" },
              { key: "Modèle du moteur", value: "1104D-44T EPA" },
              { key: "Norme moteur", value: "Stage IIIA" },
              { key: "Nombre de cylindres / Cylindrée", value: "4 - 4.40 l" },
              { key: "Puissance du moteur I.C. (ch) / Puissance (kW)", value: "92 Hp / 70 KW" },
              {
                key: "Couple max. / Régime moteur",
                value: "392 Nm",
              }
            ],
          },
          {
            id: 6,
            type: "Hydraulique",
            features: [
              {
                key: "Type de pompe hydraulique",
                value: "Gear pump",
              },
              {
                key: "Débit hydraulique - Pression hydraulique",
                value: "96.70 l / min / 250 bar",
              },
            ],
          },
          {
            id: 7,
            type: "Capacités des réservoirs",
            features: [
              {
                key: "Réservoir à carburant",
                value: "78.50 l",
              },
              {
                key: "Huile hydraulique",
                value: "120 l",
              },
            ],
          },
          {
            id: 8,
            type: "Bruit et vibration",
            features: [
              { key: "Bruit à l’environnement (LwA)", value: "110 dB(A)" },
              {
                key: "Bruit au poste de conduite (LpA)",
                value: "92 dB(A)",
              }
            ]
          },
          {
            id: 9,
            type: "Divers",
            features: [
              { key: "Volants (avant / arrière)", value: "2/2" },
              {
                key: "Roues motrices (avant / arrière)",
                value: "2/2",
              },
              {
                key: "Homologation cabine de sécurité",
                value: "Standard EN 15000",
              },
              {
                key: "Contrôles",
                value: "Monolever",
              },
            ],
          },
        ],
      },
      {
        id: 2,
        name: "Tx-408",
        description1:
          "Les chantiers exigent des performances supérieures, et c'est ce que les chariots télescopiques TX offrent. Élevant jusqu'à 7,60 m, cette machine offre une capacité de travail supplémentaire sans sacrifier le confort et les fonctionnalités attendues des chariots télescopiques TX.",
        description2: "",

        image: require("../assets/images/machines/tx408.webp"),
        images: [
          {
            image: require("../assets/images/machines/tx408.webp"),
          },
          {
            image: require("../assets/images/machines/r190-2.webp"),
          },
          {
            image: require("../assets/images/machines/r190-3.webp"),
          },
          {
            image: require("../assets/images/machines/r190-4.webp"),
          },
        ],
        video: "https://www.youtube.com/embed/1TiipMbM8_g", //NOTE: l vid lezmek tekhdou mel youtube => iframe
        ficheTechnique: [
          { key: "Hauteur de levage: ", value: "7.60 m" },
          { key: "Capacité de levage: ", value: "4000 Kg" },
          { key: "Moteur: ", value: "Perkins" },
        ],
        brochure: require("../assets/brochure/TX408.pdf"),
        technicalFeatures: [
          {
            id: 1,
            type: "Capacités",
            features: [
              { key: "Max. Capacité", value: "4000 kg" },
              {
                key: "Max. Hauteur de levage",
                value: "7.6 m",
              },
              { key: "Longueur du bras", value: "4.23 m" },
            ],
          },
          {
            id: 2,
            type: "Moteur",
            features: [
              { key: "Marque du moteur", value: "Perkins" },
              { key: "Modèle du moteur", value: "1104D-44T" },
              { key: "Norme moteur", value: "Stage 3A" },
              { key: "Nombre de cylindres / Cylindrée", value: "4 - 4400 cm³" },
              { key: "Puissance du moteur I.C. (ch) / Puissance (kW)", value: "94 Hp / 70 KW" },
              {
                key: "Couple max. / Régime moteur",
                value: "392 Nm",
              }
            ],
          },
          {
            id: 3,
            type: "Hydraulique",
            features: [
              {
                key: "Type de pompe hydraulique",
                value: "Gear pump",
              },
              {
                key: "Débit hydraulique - Pression hydraulique",
                value: "86 l / min / 250 bar",
              },
              {
                key: "Huile hydraulique",
                value: "120 l",
              },
            ],
          },
          {
            id: 4,
            type: "Transmission",
            features: [
              { key: "Type de transmission", value: "Torque converter" },
              { key: "Vitesse max. de déplacement", value: "28 Km/h" },
              { key: "Frein de parking", value: "Manuel" },
            ],
          },
          {
            id: 2,
            type: "Poids et dimensions",
            features: [
              {
                key: "Longueur hors tout au chariot",
                value: "4.93 m",
              },
              {
                key: "Largeur totale",
                value: "2.38 m",
              },
              {
                key: "Hauteur totale",
                value: "2.59 m",
              },
              { key: "Empattement", value: "2.58 m" },
              { key: "Garde au sol", value: "0.38 m" },
              { key: "Largeur hors tout de la cabine", value: " 0.85 m" },
              { key: "Rayon de braquage extérieur", value: "3.9 m" },
              { key: "Poids à vide (avec fourches)", value: "8140 kg" },
              { key: "Tailles des fourches", value: "1200  x 125  x 45" }
            ],
          },
        ],
      },
    ],
  },
];
